import * as AppPics from 'assets/images';

function Footer() {
  return (
    <div className="mainFooter">
      <a className="mainFooter__block" href="#">
        <img src={AppPics.MainFooterGuideSvg} alt="Guide" />
        <span>Help Guide</span>
      </a>
      <a className="mainFooter__block" href="#">
        <img src={AppPics.MainFooterBugSvg} alt="Bug" />
        <span>Report a bug!</span>
      </a>
    </div>
  );
}

export default Footer;
